import { z } from "zod";

/**
 * Response schema for GET /v4/sso/to-booking-engine
 * Returns a signed token to securely redirect a user to the Extranet (Booking Engine).
 */
export const RedirectToBookingEngineResponseSchema = z.object({
    success: z.boolean(),
    data: z.string(),
    signature: z.string(),
});

export type RedirectToBookingEngineResponse = z.infer<typeof RedirectToBookingEngineResponseSchema>;
